export const allowedCombinationsGuideProducts = [
    'PENTO',
    'INTEGO',
    'RONDO',
    'Q.INTEGO',
    'QUADRO.E',
    // 'RA.2',
    // 'RA.3',
    // 'KARO',
    // 'PURO.2.XR',
    // 'VISIO',
    // 'VECTO',
    // 'VECTO.E',
];

export const allowedCombinationsGuideProductGroups = [
    // 'Rolete'
];

export const allowedCombinationsGuideProductSubGroups = [
    // String.raw`Rolete\Predokenske`
];

export const alternativeAllowedCombinationsGuideProducts = [
    {
        products: ['RA.2', 'RA.3', 'KARO', 'VISIO', 'VECTO', 'VECTO.E'],
        segment: 'Omarica',
        configuratorType: 'alternative',
    },
    { products: ['PURO.2.XR'], segment: 'Lamele', configuratorType: 'simple' },
];

export const alternativeAllowedCombinationsGuideProductsForAlternativePIds = ['VISIO', 'VECTO', 'VECTO.E'];
